import axios from "axios";

// HTTP client for the PUBLIC portal (/pub). Deliberately separate from lib/api.js: its own
// token, its own storage key and its own prefix, so an admin session and a portal session
// never leak into each other's requests (the backend refuses the crossover as well, by token
// scope — this is the client-side half of the same segregation).
const PORTAL_TOKEN_KEY = "pub_token";

const portalApi = axios.create({
  withCredentials: false,          // the portal is token-only; no admin session cookie
  headers: { "Content-Type": "application/json" },
});

let token = localStorage.getItem(PORTAL_TOKEN_KEY) || null;

export function setPortalToken(next) {
  token = next || null;
  if (next) localStorage.setItem(PORTAL_TOKEN_KEY, next);
  else localStorage.removeItem(PORTAL_TOKEN_KEY);
}

export function getPortalToken() {
  return token;
}

export function clearPortalToken() {
  setPortalToken(null);
}

portalApi.interceptors.request.use((config) => {
  if (token) config.headers["Authorization"] = `Bearer ${token}`;
  if (config.url && config.url.startsWith("/")) config.url = `/pub/api${config.url}`;
  return config;
});

portalApi.interceptors.response.use(
  (r) => r,
  (error) => {
    // An expired or rejected portal session must drop the token, never fall back to the admin
    // one — landing on the admin panel from the portal would defeat the segregation.
    if (error?.response?.status === 401) clearPortalToken();
    return Promise.reject(error);
  },
);

export default portalApi;
